import { render, staticRenderFns } from "./ReferralPathwayFollowup.vue?vue&type=template&id=cae5cd46&scoped=true"
import script from "./ReferralPathwayFollowup.vue?vue&type=script&lang=js"
export * from "./ReferralPathwayFollowup.vue?vue&type=script&lang=js"
import style0 from "./ReferralPathwayFollowup.vue?vue&type=style&index=0&id=cae5cd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae5cd46",
  null
  
)

export default component.exports